import styled from '@emotion/styled';
import React, { useState } from 'react';
import { Modal } from 'antd';
import DonationNotice from '../DetailComponents/DonationNotice'
import {
  InfoModalContent,
  InfoModalHeader,
  InfoModalIcon,
  InfoModalBody,
  InfoModalText,
  InfoModalTitle,
  InfoModalList,
  InfoModalLink,
  InfoModalPrimaryLink,
  InfoModalFooter,
  InfoModalSecondaryButton,
  InfoModalPrimaryButton,
  ModalCloseButton,
} from '../../../../ProjectFormV2/components/Promotions/Modal.styles';
import { BookmarkIcon } from './Icons';
import { CloseOutlined } from '@ant-design/icons';
export default function DonationReceiptModalButton({ project, buttonComponent }) {

  const [showModal, setShowModal] = useState(false);
  const [innerWidth, setInnerWidth] = React.useState(window?.innerWidth || 0);

  React.useEffect(() => {
    const handleResize = () => setInnerWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function onClose() {
    setShowModal(false);
  }
  return (
    <>
      <DonationNotice
        onPress={() => {
          setShowModal(true);
        }}
        project={project}
      />

      <StyledModal
        open={showModal}
        onCancel={onClose}
        footer={null}
        width={600}
        closable={false}
        style={{
          borderRadius: 12,
          // marginTop: innerWidth < 475 ? 0 : undefined,
          // top: innerWidth < 475 ? 0 : undefined,
        }}
        bodyStyle={{ padding: 0, borderRadius: 12 }}
      >
        {' '}
        <InfoModalContent>
          <InfoModalHeader></InfoModalHeader>

          <InfoModalBody>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignContent: 'center',
                alignItems: 'center',
              }}
            >
              <InfoModalIcon>
                <BookmarkIcon />
              </InfoModalIcon>
              <ModalCloseButton onClick={onClose}>
                <CloseOutlined />
              </ModalCloseButton>
            </div>

            <InfoModalTitle>
              Der Projektinitiator kann Spendenquittungen ausstellen.
            </InfoModalTitle>
            <InfoModalText>
              Bestimmte Organisationen auf Commonsplace sind berechtigt,
              offizielle Spendenquittungen nach deutschem Steuerrecht
              auszustellen. Diese sind im System entsprechend markiert. Mit
              einer Spendenquittung kannst du deine Unterstützung bei der
              Steuererklärung angeben und so steuerlich absetzen.
            </InfoModalText>
            <InfoModalTitle>
              Wie erhalte ich meine Spendenquittung?
            </InfoModalTitle>
            <InfoModalText>
              <strong>Unter 300 €:</strong> Für deine Steuererklärung reicht
              bereits der Zahlungsnachweis (z. B. Kontoauszug oder
              Zahlungsbestätigung per E-Mail von uns). Eine gesonderte
              Spendenquittung ist hier nicht notwendig.
            </InfoModalText>
            <InfoModalText>
              <strong>Über 300 €:</strong> Nach deiner Unterstützung erhältst du
              eine E-Mail mit den Kontaktdaten der Organisation. Dort kannst du
              direkt deine Spendenquittung anfordern. Die Organisation stellt
              dir diese dann offiziell aus.
            </InfoModalText>
            <InfoModalTitle>Wichtige Hinweise</InfoModalTitle>

            <InfoModalList>
              <li>
                Spendenquittungen können nur von Organisationen ausgestellt
                werden, die in Deutschland als gemeinnützig anerkannt sind.
              </li>
              <li style={{ marginTop: 4 }}>
                Falls du mehrere Spenden an dieselbe Organisation leistest,
                kannst du meist eine Jahresquittung erhalten – frage dafür
                direkt bei der Organisation nach.
              </li>
              <li>
                Die Ausstellung kann etwas Zeit in Anspruch nehmen, da viele
                Organisationen ihre Belege gesammelt am Jahresende verschicken.
              </li>
              <li>
                Für Unterstützungen an Projekte ohne Gemeinnützigkeitsstatus
                kann keine Spendenquittung erstellt werden.
              </li>
            </InfoModalList>

            {/*<InfoModalPrimaryLink style={{ display: 'block', marginTop: '16px' }}>*/}
            {/*  Weitere Details finden sich im Infoblatt (PDF).*/}
            {/*</InfoModalPrimaryLink>*/}
          </InfoModalBody>

          <InfoModalFooter>
            <InfoModalPrimaryButton onClick={onClose}>
              Verstanden
            </InfoModalPrimaryButton>
          </InfoModalFooter>
        </InfoModalContent>
      </StyledModal>
    </>
  );

}


const StyledModal = styled(Modal)`
.ant-modal-content {
  border-radius: 12px;
}
`;